export default "__VITE_ASSET__BCJ2zW5j__"